/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteDistrictCommand } from '../../models/delete-district-command';
import { DeleteDistrictCommandResult } from '../../models/delete-district-command-result';

export interface ApiDistrictDeleteDistrictDelete$Plain$Params {
      body?: DeleteDistrictCommand
}

export function apiDistrictDeleteDistrictDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiDistrictDeleteDistrictDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteDistrictCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictDeleteDistrictDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteDistrictCommandResult>;
    })
  );
}

apiDistrictDeleteDistrictDelete$Plain.PATH = '/api/District/DeleteDistrict';
